import { Model } from "@/models/Model";
import idb from "@/libraries/indexedDB";
export class ModelIndexedDB extends Model {
    constructor(table, id = null) {
        super();
        this.table = table;
        this._id = id;
    }
    async init() {
        if (!this._id) {
            return;
        }
        this.setData(await this.getDataFromDB(this._id));
    }
    getDataFromDB(id) {
        return idb.findOne(this.table, id);
    }
    setDataToDB(id) {
        idb.saveOne(this.table, id, this.getData());
    }
    getTableData() {
        return idb.restore(this.table);
    }
    setTableData(data) {
        idb.save(this.table, data);
    }
    async getList() {
        const all = await this.getTableData();
        return all.map(v => new this.constructor(v.id));
    }
    delete() {
        return idb.removeOne(this.table, this.id);
    }
}
